function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import "../polizaRenewal.scss";
import Select from "react-select";
import CurrencyInput from "../../../helperComponents/CurrencyInput/CurrencyInput";
import { getCurrencyByString } from "../../../utils/currency";
import { getSeparatorByCurrency } from "../../../utils/currency";
import Footer from "./Footer";
import { update, finish, reset } from "../actions/PolizaRenewalActions";
import { filename } from "../../../utils/InputUtils";

var PolizaRenewalForm = function PolizaRenewalForm(props) {
  var _polizaRenewal$poliza, _polizaRenewal$poliza2, _polizaRenewal$poliza3, _polizaRenewal$poliza4, _polizaRenewal$poliza5, _polizaRenewal$poliza6, _polizaRenewal$poliza7, _polizaRenewal$poliza8, _polizaRenewal$poliza9, _polizaRenewal$poliza10, _polizaRenewal$poliza11, _polizaRenewal$poliza12;

  var token = props.token,
      polizaRenewal = props.polizaRenewal,
      conditions = props.conditions,
      conditionUpdateReasons = props.conditionUpdateReasons,
      clientRejectsRenewalReasons = props.clientRejectsRenewalReasons,
      companyRejectsRenewalReasons = props.companyRejectsRenewalReasons,
      _onChange = props.onChange;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      companyConditionsDocument = _React$useState2[0],
      setCompanyConditionsDocument = _React$useState2[1];

  React.useEffect(function () {
    var _polizaRenewal$compan;

    setCompanyConditionsDocument((_polizaRenewal$compan = polizaRenewal.company_conditions_document) === null || _polizaRenewal$compan === void 0 ? void 0 : _polizaRenewal$compan.company_conditions_document);
  }, [polizaRenewal]);

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isLoading = _React$useState4[0],
      setIsLoading = _React$useState4[1];

  var currency = getCurrencyByString(polizaRenewal.poliza.currency);
  var currencyInput = getSeparatorByCurrency(currency);
  var affects_percent = ((_polizaRenewal$poliza = polizaRenewal.poliza) === null || _polizaRenewal$poliza === void 0 ? void 0 : (_polizaRenewal$poliza2 = _polizaRenewal$poliza.commission) === null || _polizaRenewal$poliza2 === void 0 ? void 0 : _polizaRenewal$poliza2.affects_net_bonus) && ((_polizaRenewal$poliza3 = polizaRenewal.poliza) === null || _polizaRenewal$poliza3 === void 0 ? void 0 : (_polizaRenewal$poliza4 = _polizaRenewal$poliza3.commission) === null || _polizaRenewal$poliza4 === void 0 ? void 0 : _polizaRenewal$poliza4.affects_net_bonus) / ((_polizaRenewal$poliza5 = polizaRenewal.poliza) === null || _polizaRenewal$poliza5 === void 0 ? void 0 : (_polizaRenewal$poliza6 = _polizaRenewal$poliza5.commission) === null || _polizaRenewal$poliza6 === void 0 ? void 0 : _polizaRenewal$poliza6.net_bonus);
  var exempt_percent = ((_polizaRenewal$poliza7 = polizaRenewal.poliza) === null || _polizaRenewal$poliza7 === void 0 ? void 0 : (_polizaRenewal$poliza8 = _polizaRenewal$poliza7.commission) === null || _polizaRenewal$poliza8 === void 0 ? void 0 : _polizaRenewal$poliza8.exempt_net_bonus) && ((_polizaRenewal$poliza9 = polizaRenewal.poliza) === null || _polizaRenewal$poliza9 === void 0 ? void 0 : (_polizaRenewal$poliza10 = _polizaRenewal$poliza9.commission) === null || _polizaRenewal$poliza10 === void 0 ? void 0 : _polizaRenewal$poliza10.exempt_net_bonus) / ((_polizaRenewal$poliza11 = polizaRenewal.poliza) === null || _polizaRenewal$poliza11 === void 0 ? void 0 : (_polizaRenewal$poliza12 = _polizaRenewal$poliza11.commission) === null || _polizaRenewal$poliza12 === void 0 ? void 0 : _polizaRenewal$poliza12.net_bonus) || 0;

  var savePolizaRenewal = function savePolizaRenewal() {
    setIsLoading(true);
    update(polizaRenewal, token).then(function (response) {
      //fetch(`/api/v1/poliza_renewals/${polizaRenewal.id}`, {
      //  method: "PATCH",
      //  headers: {
      //    "X-CSRF-Token": token,
      //    'Content-Type': 'application/json;charset=utf-8'
      //  },
      //  body: JSON.stringify({poliza_renewal_attributes: polizaRenewal}),
      //}).then((response) => {
      response.json().then(function (updateResponse) {
        _onChange(updateResponse.poliza_renewal);

        setIsLoading(false);
      })["catch"](function (error) {
        setIsLoading(false);
        console.error(error);
        return {
          status: error.status
        };
      });
    })["catch"](function (error) {
      setIsLoading(false);
      console.error(error);
      return {
        status: error.status
      };
    });
  };

  var finishPolizaRenewal = function finishPolizaRenewal() {
    setIsLoading(true);
    finish(polizaRenewal, token).then(function (response) {
      //fetch(`/api/v1/poliza_renewals/${polizaRenewal.id}/finish`, {
      //  method: "POST",
      //  headers: {
      //    "X-CSRF-Token": token,
      //    'Content-Type': 'application/json;charset=utf-8'
      //  },
      //  body: JSON.stringify({poliza_renewal_attributes: polizaRenewal}),
      //}).then((response) => {
      response.json().then(function (updateResponse) {
        _onChange(updateResponse.poliza_renewal);

        setIsLoading(false);
      })["catch"](function (error) {
        setIsLoading(false);
        console.error(error);
        return {
          status: error.status
        };
      });
    })["catch"](function (error) {
      setIsLoading(false);
      console.error(error);
      return {
        status: error.status
      };
    });
  };

  var resetPolizaRenewal = function resetPolizaRenewal() {
    setIsLoading(true);
    reset(polizaRenewal, token).then(function (response) {
      //fetch(`/api/v1/poliza_renewals/${polizaRenewal.id}/reset`, {
      //  method: "POST",
      //  headers: {
      //    "X-CSRF-Token": token,
      //    'Content-Type': 'application/json;charset=utf-8'
      //  },
      //  body: JSON.stringify({poliza_renewal_attributes: polizaRenewal}),
      //}).then((response) => {
      response.json().then(function (updateResponse) {
        _onChange(updateResponse.poliza_renewal);

        setIsLoading(false);
      })["catch"](function (error) {
        setIsLoading(false);
        console.error(error);
        return {
          status: error.status
        };
      });
    })["catch"](function (error) {
      setIsLoading(false);
      console.error(error);
      return {
        status: error.status
      };
    });
  };

  var renderNewPrimaForm = function renderNewPrimaForm() {
    var _polizaRenewal$poliza13, _polizaRenewal$poliza14, _polizaRenewal$poliza15, _polizaRenewal$poliza16, _polizaRenewal$poliza17, _polizaRenewal$poliza18, _polizaRenewal$poliza19, _polizaRenewal$poliza20, _polizaRenewal$poliza21, _polizaRenewal$poliza22, _polizaRenewal$poliza23, _polizaRenewal$poliza24;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza13 = polizaRenewal.poliza) === null || _polizaRenewal$poliza13 === void 0 ? void 0 : (_polizaRenewal$poliza14 = _polizaRenewal$poliza13.commission) === null || _polizaRenewal$poliza14 === void 0 ? void 0 : _polizaRenewal$poliza14.affects_net_bonus,
      currency: currency,
      disabled: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza15 = polizaRenewal.poliza) === null || _polizaRenewal$poliza15 === void 0 ? void 0 : (_polizaRenewal$poliza16 = _polizaRenewal$poliza15.commission) === null || _polizaRenewal$poliza16 === void 0 ? void 0 : _polizaRenewal$poliza16.exempt_net_bonus,
      currency: currency,
      disabled: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Prima neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: (_polizaRenewal$poliza17 = polizaRenewal.poliza) === null || _polizaRenewal$poliza17 === void 0 ? void 0 : (_polizaRenewal$poliza18 = _polizaRenewal$poliza17.commission) === null || _polizaRenewal$poliza18 === void 0 ? void 0 : _polizaRenewal$poliza18.net_bonus,
      currency: currency,
      disabled: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva Prima neta afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: polizaRenewal.affects_net_bonus || ((_polizaRenewal$poliza19 = polizaRenewal.poliza) === null || _polizaRenewal$poliza19 === void 0 ? void 0 : (_polizaRenewal$poliza20 = _polizaRenewal$poliza19.commission) === null || _polizaRenewal$poliza20 === void 0 ? void 0 : _polizaRenewal$poliza20.affects_net_bonus),
      currency: currency,
      onValueChange: function onValueChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          affects_net_bonus: parseFloat(value.replace(",", ".")),
          net_bonus: parseFloat(value.replace(",", ".")) + polizaRenewal.exempt_net_bonus
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva Prima neta exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      defaultValue: polizaRenewal.exempt_net_bonus || ((_polizaRenewal$poliza21 = polizaRenewal.poliza) === null || _polizaRenewal$poliza21 === void 0 ? void 0 : (_polizaRenewal$poliza22 = _polizaRenewal$poliza21.commission) === null || _polizaRenewal$poliza22 === void 0 ? void 0 : _polizaRenewal$poliza22.exempt_net_bonus),
      currency: currency,
      onValueChange: function onValueChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          exempt_net_bonus: parseFloat(value.replace(",", ".")),
          net_bonus: parseFloat(value.replace(",", ".")) + polizaRenewal.affects_net_bonus
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Nueva Prima neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
      className: "form-control",
      value: polizaRenewal.net_bonus || ((_polizaRenewal$poliza23 = polizaRenewal.poliza) === null || _polizaRenewal$poliza23 === void 0 ? void 0 : (_polizaRenewal$poliza24 = _polizaRenewal$poliza23.commission) === null || _polizaRenewal$poliza24 === void 0 ? void 0 : _polizaRenewal$poliza24.net_bonus),
      currency: currency,
      disabled: true
    }))));
  };

  var renderPolizaRenewalForm = function renderPolizaRenewalForm() {
    var _polizaRenewal$poliza25, _polizaRenewal$poliza26, _polizaRenewal$poliza27, _polizaRenewal$poliza28;

    if (polizaRenewal && (!((_polizaRenewal$poliza25 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza25 !== void 0 && (_polizaRenewal$poliza26 = _polizaRenewal$poliza25.commission) !== null && _polizaRenewal$poliza26 !== void 0 && _polizaRenewal$poliza26.net_bonus) || !((_polizaRenewal$poliza27 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza27 !== void 0 && (_polizaRenewal$poliza28 = _polizaRenewal$poliza27.commission) !== null && _polizaRenewal$poliza28 !== void 0 && _polizaRenewal$poliza28.affects_net_bonus))) {
      return /*#__PURE__*/React.createElement("p", null, "No es posible ingresar condiciones de renovaci\xF3n de una poliza sin prima ingresada.");
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Condici\xF3n de renovaci\xF3n"), /*#__PURE__*/React.createElement(Select, {
      options: conditions,
      defaultValue: conditions.find(function (condition) {
        return polizaRenewal.condition === condition.value;
      }),
      name: "polizaRenewal[condition]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona condición de renovación",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "change_conditions" && /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n del cambio de condiciones"), /*#__PURE__*/React.createElement(Select, {
      options: conditionUpdateReasons,
      defaultValue: conditionUpdateReasons.find(function (condition) {
        return polizaRenewal.condition_update_reason === condition.value;
      }),
      name: "polizaRenewal[condition_update_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Seleccione una razón del cambio de condiciones",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition_update_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "client_rejects_renewal" && /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n de rechazo (Cliente)"), /*#__PURE__*/React.createElement(Select, {
      options: clientRejectsRenewalReasons,
      defaultValue: clientRejectsRenewalReasons.find(function (condition) {
        return polizaRenewal.client_rejects_renewal_reason === condition.value;
      }),
      name: "polizaRenewal[client_rejects_renewal_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona razón de rechazo de parte del Cliente...",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          client_rejects_renewal_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    })), polizaRenewal.condition == "company_rejects_renewal" && /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Raz\xF3n de rechazo (Compa\xF1\xEDa)"), /*#__PURE__*/React.createElement(Select, {
      options: companyRejectsRenewalReasons,
      defaultValue: companyRejectsRenewalReasons.find(function (condition) {
        return polizaRenewal.company_rejects_renewal_reason === condition.value;
      }),
      name: "polizaRenewal[company_rejects_renewal_reason]",
      isSearchable: true,
      isClearable: true,
      placeholder: "Selecciona razón de rechazo de parte de la Compañía...",
      onChange: function onChange(item) {
        return _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          company_rejects_renewal_reason: item === null || item === void 0 ? void 0 : item.value
        }));
      }
    }))), polizaRenewal.condition === "change_conditions" && polizaRenewal.condition_update_reason === "change_prima" && renderNewPrimaForm(), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-3"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Solicitado Inspeccionar"), polizaRenewal.inspection_needed, /*#__PURE__*/React.createElement("div", {
      className: "checkbox"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      onChange: function onChange(event) {
        _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          inspection_needed: event.target.checked
        }));
      },
      checked: polizaRenewal.inspection_needed
    }), "Inspecci\xF3n requerida"))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-6"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Condiciones de la compa\xF1\xEDa"), /*#__PURE__*/React.createElement("input", {
      className: "form-control",
      type: "file",
      onChange: function onChange(event) {
        if (companyConditionsDocument !== null && companyConditionsDocument !== void 0 && companyConditionsDocument.url) {
          _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
            company_conditions_document: event.target.files[0]
          }));
          setCompanyConditionsDocument(null);
        } else {
          _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
            company_conditions_document: event.target.files[0]
          }));
        }
      }
    }), (companyConditionsDocument === null || companyConditionsDocument === void 0 ? void 0 : companyConditionsDocument.url) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: companyConditionsDocument.url
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-file"
    }), filename(companyConditionsDocument === null || companyConditionsDocument === void 0 ? void 0 : companyConditionsDocument.url.split("/"))))), /*#__PURE__*/React.createElement("div", {
      className: "col-md-9"
    }, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, "Detalles de la condici\xF3n"), /*#__PURE__*/React.createElement("textarea", {
      className: "form-control",
      rows: 12,
      placeholder: "Completar detalles de las condiciones...",
      value: (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.condition_details) || "",
      onChange: function onChange(event) {
        return _onChange && _onChange(_objectSpread(_objectSpread({}, polizaRenewal), {}, {
          condition_details: event.target.value
        }));
      }
    }))));
  };

  var renderErrors = function renderErrors() {
    var _polizaRenewal$errors;

    if (polizaRenewal !== null && polizaRenewal !== void 0 && (_polizaRenewal$errors = polizaRenewal.errors) !== null && _polizaRenewal$errors !== void 0 && _polizaRenewal$errors.messages) {
      return polizaRenewal.errors.messages.map(function (message) {
        return /*#__PURE__*/React.createElement("div", {
          className: "alert alert-danger"
        }, " ", message, " ");
      });
    } else {
      return null;
    }
  };

  function cannotEditPolizaRenewal() {
    return (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "renewed" || (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "not_renewed";
  }

  function cannotSaveConditions() {
    return (polizaRenewal === null || polizaRenewal === void 0 ? void 0 : polizaRenewal.aasm_state) === "with_conditions";
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "form-horizontal col-md-12 cntPolizaForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header cardHeader"
  }, "Renovaci\xF3n de poliza"), /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, renderErrors(), polizaRenewal && renderPolizaRenewalForm(), isLoading ? /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: true
  }, "Guardando...") : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-default",
    onClick: function onClick() {
      !cannotEditPolizaRenewal() && savePolizaRenewal();
    },
    disabled: cannotEditPolizaRenewal()
  }, "Guardar"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      !cannotEditPolizaRenewal() && !cannotSaveConditions() && finishPolizaRenewal();
    },
    disabled: cannotEditPolizaRenewal() || cannotSaveConditions()
  }, cannotSaveConditions() ? "Condiciones cargadas" : "Marcar Condición cargada"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-danger",
    onClick: resetPolizaRenewal
  }, "Reset")))), /*#__PURE__*/React.createElement("div", {
    className: "card-footer cardFooter"
  }), /*#__PURE__*/React.createElement(Footer, {
    polizaRenewal: polizaRenewal
  })));
};

export default PolizaRenewalForm;